// extracted by mini-css-extract-plugin
module.exports = {"wr":"noMatch_wr__3ubvj","content":"noMatch_content__1JYP2","text":"noMatch_text__89fcs","error":"noMatch_error__PxOUL"};